import { COLORS, FONTS, TYPE, SPACING } from "../theme.js";

// Minimal — sans-serif, lots of whitespace, hairline dividers, low chrome.
export const minimalStyles = {
  meta: { label: "Minimal (clean)" },

  page: {
    paddingTop: 48,
    paddingBottom: 48,
    paddingLeft: 56,
    paddingRight: 56,
    backgroundColor: COLORS.white,
    fontFamily: FONTS.sans,
    fontSize: TYPE.body,
    color: COLORS.navy,
    lineHeight: 1.45,
  },

  header: { marginBottom: 14 },
  headerName: {
    fontSize: TYPE.name,
    fontFamily: FONTS.sansBold,
    color: COLORS.navy,
    letterSpacing: 0.4,
    marginBottom: 12,
  },
  headerHeadline: {
    fontSize: TYPE.headline,
    color: COLORS.slate,
    marginTop: 2,
  },
  headerContact: {
    fontSize: TYPE.micro,
    color: COLORS.slate,
    marginTop: 5,
  },
  sep: { color: COLORS.mute },

  section: { marginTop: 16 },
  sectionHeadingWrap: { marginBottom: 6 },
  sectionHeading: {
    fontSize: TYPE.micro,
    fontFamily: FONTS.sansBold,
    textTransform: "uppercase",
    letterSpacing: 2.5,
    color: COLORS.mute,
  },

  itemGroup: { marginBottom: 10 },
  itemGroupTight: { marginBottom: 5 },
  itemRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-end",
  },
  itemTitle: {
    fontSize: TYPE.itemTitle,
    fontFamily: FONTS.sansBold,
    color: COLORS.navy,
  },
  itemTitleAlt: { fontFamily: FONTS.sans, color: COLORS.slate },
  itemTitleMuted: { fontFamily: FONTS.sans, color: COLORS.mute },
  itemSubtitle: {
    fontSize: TYPE.body,
    color: COLORS.slate,
    marginTop: 1,
  },
  itemDate: { fontSize: TYPE.meta, color: COLORS.mute },

  body: { fontSize: TYPE.body, color: COLORS.navy, marginTop: 2 },
  meta: { fontSize: TYPE.meta, color: COLORS.slate, marginTop: 2 },
  chipsLine: { fontSize: TYPE.meta, marginTop: 3, color: COLORS.slate },
  labelStrong: { fontFamily: FONTS.sansBold, color: COLORS.navy },
  italic: { fontFamily: FONTS.sansItalic },

  bullets: { marginTop: 4 },
  bulletRow: { flexDirection: "row", marginBottom: 2 },
  bulletMark: { width: 10, fontSize: TYPE.body, color: COLORS.mute },
  bulletText: { flex: 1, fontSize: TYPE.body, color: COLORS.navy },

  link: { color: COLORS.rust, textDecoration: "underline" },
  linkSmall: {
    color: COLORS.rust,
    textDecoration: "underline",
    fontSize: TYPE.meta,
  },
};
